import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: 'BONO 1',
    title: 'RESET DE CREENCIAS DE ESCASEZ',
    desc: 'Detectá y reemplazá las creencias invisibles que hoy te frenan. Test de autodiagnóstico completo. Sistema de reencuadre PNL. 15 reemplazos listos para usar. Rutina de reprogramación diaria de 5 minutos.',
    value: '$12.000'
  }, {
    num: 'BONO 2',
    title: 'MANUAL DE ANCLAJES RÁPIDOS',
    desc: 'Aprendé a cambiar tu estado emocional en minutos. 7 protocolos de anclaje para los estados más críticos. Protocolo de emergencia de 90 segundos. Tracker de práctica de 21 días.',
    value: '$10.000'
  }, {
    num: 'BONO 3',
    title: 'PLANNER DE ABUNDANCIA 30 DÍAS',
    desc: 'Convertí el conocimiento en acción diaria sostenida. Páginas de seguimiento diario. Revisión semanal. Tracker de hábitos soberanos. Evaluación final del mes con plan para el siguiente ciclo.',
    value: '$9.000'
  }, {
    num: 'BONO 4',
    title: 'DICCIONARIO DE LENGUAJE NO VERBAL',
    desc: 'Aprendé a leer señales clave en otras personas. Glosario completo zona por zona del cuerpo. 40 señales frecuentes. Guía de uso por contexto. Desafío de observación de 7 días.',
    value: '$10.000'
  }, {
    num: 'BONO 5',
    title: 'RITUALES DE LIMPIEZA Y ENFOQUE PERSONAL',
    desc: 'Rituales simples para despejar carga mental y recuperar tu centro. 12 rituales completos paso a paso. Plantillas de intención. Checklist mensual de práctica. Para usar en cualquier momento del día.',
    value: '$9.000'
  }, {
    num: 'BONO 6',
    title: 'CUADERNO DE REPROGRAMACIÓN PERSONAL',
    desc: 'Sistema de escritura guiada para vaciar el ruido mental y detectar tus patrones. Ejercicios de vaciado. Preguntas de conciencia profunda. Journaling diario guiado. Hoja de nueva identidad.',
    value: '$9.000'
  }];
  return <section className="py-20 md:py-32 px-4 bg-dark-card/50" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-20">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-21">
            <Gift className="w-8 h-8 text-gold" data-id="element-22" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white" data-id="element-23">
            6 BONOS INCLUIDOS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-24">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark border border-dark-border rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-25">
              {/* Ribbon effect */}
              <div className="absolute top-0 right-0 w-24 h-24 overflow-hidden" data-id="element-26">
                <div className="absolute top-4 -right-8 w-32 bg-gold text-dark text-xs font-bold py-1 text-center rotate-45 shadow-md" data-id="element-27">
                  GRATIS
                </div>
              </div>

              <div className="text-gold-light font-bold text-sm tracking-widest mb-2" data-id="element-28">
                {bono.num}
              </div>
              <h4 className="text-xl font-heading font-bold text-white mb-4 pr-8" data-id="element-29">
                {bono.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-grow" data-id="element-30">
                {bono.desc}
              </p>

              <div className="mt-auto pt-4 border-t border-dark-border/50" data-id="element-31">
                <p className="text-sm" data-id="element-32">
                  <span className="text-gray-500 line-through mr-2" data-id="element-33">
                    Valor: {bono.value}
                  </span>
                  <span className="text-gold font-bold uppercase tracking-wide" data-id="element-34">
                    GRATIS con tu MegaPack
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold/20 via-gold/10 to-gold/20 border border-gold/30 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-35">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-36">
            Valor total bonos:{' '}
            <span className="text-gold line-through opacity-70" data-id="element-37">$59.000</span>
            <br className="md:hidden" data-id="element-38" />
            <span className="text-gold-light ml-2" data-id="element-39">
              — GRATIS con tu MegaPack
            </span>
          </h3>
        </motion.div>
      </div>
    </section>;
}